import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idcard'
})
export class IdCardPipe implements PipeTransform {

  transform(value: string): string {
    if (value) {
      let idCard = '';
      idCard = idCard + value.substr(0, 1) + '-';
      idCard = idCard + value.substr(1, 4) + '-';
      idCard = idCard + value.substr(5, 5) + '-';
      idCard = idCard + value.substr(10, 2) + '-';
      idCard = idCard + value.substr(12, 1)
      return idCard;
    }

  }

}
